module.exports = __webpack_public_path__ + "static/media/pink_animal_mammals.12c16a0a.webp";